import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "../lib/api";
import { GiftStatusCard } from "../pages/ManageGiving";

export function MyGiving() {
  const [gifts, setGifts] = useState(null);
  const load = useCallback(() => api.get("/me/giving").then((r) => setGifts(r.data || [])).catch(() => setGifts([])), []);
  useEffect(() => { load(); }, [load]);
  const monthly = (gifts || []).filter((g) => g.giving_type === "monthly");
  const oneTime = (gifts || []).filter((g) => g.giving_type !== "monthly");
  return (
    <section data-testid="dashboard-my-giving">
      <div className="flex items-end justify-between mb-4">
        <div><div className="eyebrow mb-1">My Giving</div><h2 className="font-serif text-2xl" style={{ color: "var(--burgundy)" }}>Your support of the Temple.</h2></div>
        <Link to="/give" className="text-xs ink-link" style={{ color: "var(--burgundy)" }} data-testid="my-giving-give-link">Give</Link>
      </div>
      {gifts === null ? null : gifts.length === 0 ? (
        <div className="rounded-xl border p-6 text-sm text-center" style={{ background: "var(--bg-cream-card)", borderColor: "var(--border-cream)", color: "var(--text-muted)" }}>
          <Heart className="w-5 h-5 mx-auto mb-2" style={{ color: "var(--gold-dark)" }} />No gifts yet. Giving is optional — <Link to="/give" className="ink-link font-medium" style={{ color: "var(--burgundy)" }}>learn how giving sustains the Temple</Link>.
        </div>
      ) : (
        <div className="space-y-3">
          {monthly.map((g) => <GiftStatusCard key={g.id} gift={g}
            onCancel={async () => { await api.post(`/me/giving/${g.id}/cancel`); await load(); }}
            onPortal={async () => (await api.post(`/me/giving/${g.id}/portal`, { return_url: window.location.href })).data.url} />)}
          {oneTime.length > 0 && (
            <ul className="rounded-2xl border divide-y overflow-hidden" style={{ background: "var(--bg-cream-card)", borderColor: "var(--border-cream)" }} data-testid="my-giving-one-time-list">
              {oneTime.map((g) => (
                <li key={g.id} className="flex items-center justify-between gap-4 px-4 py-3 text-sm" data-testid={`my-gift-row-${g.id}`}>
                  <div><div className="font-serif" style={{ color: "var(--burgundy)" }}>One-time gift</div><div className="text-xs" style={{ color: "var(--text-muted)" }}>{(g.paid_at || g.created_at || "").slice(0, 10)}</div></div>
                  <div className="text-right"><div className="font-serif" style={{ color: "var(--burgundy)" }}>${(g.amount_cents / 100).toFixed(2)}</div><div className="text-[10px] font-mono uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>{g.status}</div></div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </section>
  );
}
